import styled from 'styled-components';

import {
  subMenuDropdownBackground,
  primaryColorLight,
  primaryColorWeak,
} from '../../config/colors';

export const DocumentationListWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${subMenuDropdownBackground};
    padding: 25px 35px 30px 25px;

    @media print {
      background-color: inherit;
    }
`;

export const HeaderText = styled.p`
  margin-bottom: 35px;
`;

export const TableWrapper = styled.div`
  width: 100%;
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    background-color: white;
    table-layout: fixed;
    word-break: break-word;
    thead {
      th:nth-child(4) {
        width: 30%;
      }
      th:nth-child(6) {
        width: 6%;
      }
      th:nth-child(7) {
        width: 6%;
      }
    }
  }
  td, th {
    padding: 10px;
    border: 2px solid ${primaryColorLight};
  }
  th {
    background-color: ${primaryColorWeak};
  }
  tr {
    td:first-child {
      width: 19%;
    }
    td:nth-child(2) {
      width: 19%;
    }
    td:nth-child(3),
    td:nth-child(4),
    td:nth-child(5) {
      width: 14%;
    }
    td:nth-child(6) {
      width: 8%;
    }
    td:nth-child(7) {
      width: 12%;
      padding: 0;
    }
  }

  @media print {
    table {
      th, td {
         padding: 7px;
         overflow: hidden;
      }
    }
  }
`;
